import { HTTP } from '../../http-common'

export default {
  state: {
    loadedDeviceTypes: []
  },
  getters: {
    loadedDeviceTypes (state) {
      return state.loadedDeviceTypes
    }
  },
  mutations: {
    setLoadedDeviceTypes (state, payload) {
      state.loadedDeviceTypes = payload
    },
    createDeviceType (state, payload) {
      state.loadedDeviceTypes.push(payload)
    },
    updateDeviceType (state, payload) {
      state.loadedDeviceTypes = state.loadedDeviceTypes.map(deviceType => deviceType.id === payload.id ? payload : deviceType)
    },
    removeDeviceType (state, id) {
      state.loadedDeviceTypes = state.loadedDeviceTypes.filter(roof => {
        return roof.id !== id
      })
    },
    clearLoadedDeviceTypes (state) {
      state.loadedDeviceTypes = []
    }
  },
  actions: {
    loadDeviceTypes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedDeviceTypes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('device_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedDeviceTypes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createDeviceType ({ commit, getters }, payload) {
      console.log('createDeviceType')
      commit('clearError')
      commit('setLoading', true)
      const newDeviceType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('device_type.json/', newDeviceType)
          .then(result => {
            console.log(result)
            commit('createDeviceType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateDeviceType ({ commit, getters }, payload) {
      console.log('updateDeviceType')
      commit('clearError')
      commit('setLoading', true)
      const roof = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`device_type.json/${payload.id}/`, roof)
          .then(result => {
            console.log(result)
            commit('updateDeviceType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeDeviceType ({ commit }, payload) {
      console.log('removeDeviceType')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`device_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeDeviceType', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedDeviceTypes ({ commit }) {
      commit('clearLoadedDeviceTypes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device_type/index.js